<template>
  <!-- 选择用户 -->
  <el-dialog class="h-select-user" :title="title" :visible.sync="visible" width="30%">

    <div slot="title" class="dialog-title">选择用户</div>
    <div class="user-content">
      <div class="user-selected-view">

        <div class="user-selected-box">
          <div class="user-selected-item" v-for="(item,index) in curUserList" :key="index" @click="removeSelectedUser(index)">{{item.name}} <i class="el-icon-close"></i></div>
        </div>
        <div class="opt-btn-view">
          <el-button type="primary" @click="submit()" :disabled="disabled" style="background-color: #084FF7;">
            确定({{curUser.length}}/{{userList.length}})
          </el-button>
          <el-button type="primary" @click="visible = false" :disabled="disabled" plain>
            取消
          </el-button>

        </div>
      </div>
      <div class="user-select-view">
        <div class="current-departments">
          <div class="department-top" @click="pickHistoryDepartment(-1)"><i class="el-icon-office-building"></i> {{departmentTop.deptName}}</div>
          <div class="department-name" v-for="(item,index) in curDepartment" :key='index' @click="pickHistoryDepartment(index)">
            <i class="el-icon-arrow-right"></i>
            {{item.deptName}}
          </div>
        </div>
        <div class="department-view">
          <div class="select-view" v-for="(item,index) in subDepartmentList" :key='index'>
            <!-- <div class="select-view-icon active"><i class="el-icon-check" style="font-weight:bold"></i></div> -->
            <div class="select-view-name">
              {{item.deptName}}
            </div>
            <div class="sub-department" @click="pickDepartment(item,index)">
              <i class="el-icon-s-unfold"></i>
              <span> 下级</span>
            </div>
          </div>
        </div>
        <div class="select-user-view">
          <template v-for="(item,index) in userList">
            <div class="select-user-item" @click="pickUser(item)" :key="index" v-if="(curDepartment.length>0&&item.departmentId==curDepartment[curDepartment.length-1].id)||(curDepartment.length==0&&(item.departmentId==null||item.departmentId=='-1'))">
              <div class="select-view-icon" :class="checkUserIsChecked(item)?'active':''"><i class="el-icon-check" style="font-weight:bold"></i></div>
              <div class="user-icon">{{userNameIcon(item.name)}}</div>
              <div class="user-name">{{item.name}}</div>
            </div>
          </template>

        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      loading: { lock: false, text: '拼命加载中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.3)' },
      refName: '',
      visible: false,
      departmentTop: '',

      tableData: [],//当前部门下的成员列表
      tableData2: [],
      celectedUser: [],
      celectedUser2: [],
      keywords: '',
      disabled: false,
      userList: [],
      departmentList: [],//部门列表
      curDepartment: [],
      curUser: [],//当前选中用户
      curUserList: [],

    }
  },
  props: {
    // 标题
    title: {
      type: String,
      default: '选择用户'
    },
    getCurrentUserdepartmentTopApi: {
      type: String,
      default: 'getCurrentUserdepartmentTop'
    },
    type: {
      type: String,
      default: 'radio'//单选 radio 多选 multiple
    },
    value: {
      type: String || Array
    }

  },
  created () {
    this.refName = 'hSelectUser' + this._uid

  },
  watch: {
    visible (val) {
      if (val) {
        this.init()
      }
    },


  },
  computed: {
    // 当前下级部门
    subDepartmentList () {
      if (this.curDepartment.length == 0) {
        return this.departmentList
      } else {

        return this.curDepartment[this.curDepartment.length - 1].children || []
      }

    },
    // 判断用户是否选中
    checkUserIsChecked () {
      return (user) => {
        if (this.curUser.indexOf(user.id) == -1) {
          return false
        } else {
          return true
        }
      }

    },
  },
  methods: {
    // 初始化数据
    init () {
      this.getdepartmentTop()
      this.getUserList()
      this.getDepartments()
      this.curDepartment = []
      this.curUser = []
      this.curUserList = []
      this.disabled = false
    },
    // 获取所在组织名称
    getdepartmentTop () {
      let data = {}
      data.dept_id = '-1'
      this.$API.getDepartmentDetail(data).then(
        res => {
          this.departmentTop = res
        },
        err => {

        }
      )

    },
    // 获取员工列表
    getUserList () {
      let data = {}
      this.$API.getEmployeeList(data).then(
        res => {
          this.userList = res
        },
        err => {

        }
      )

    },
    // 获取部门列表
    getDepartments (item) {
      var item = item || {}
      let data = {}
      data.supDeptCode = item.deptCode || ''
      this.$API.getDepartmentList(data).then(
        res => {
          if (this.departmentList.length == 0) {
            this.departmentList = res

          } else {
            let fn = (list) => {
              for (let i = 0; i < list.length; i++) {
                if (list[i].deptCode == item.deptCode) {
                  list[i].children = res
                } else {
                  if (list[i].children && list[i].children.length > 0) {
                    fn(list[i].children)
                  }
                }

              }

            }
            fn(this.departmentList)
          }
          if (item.deptCode) {
            this.curDepartment.push(item)
          }

        },
        err => {

        }
      )

    },
    // 选择下级
    pickDepartment (item, index) {
      if (item.children && item.children.length == 0) {
        this.curDepartment.push(item)
      } else {
        this.getDepartments(item)
      }
    },
    // 选择历史选定部门
    pickHistoryDepartment (i) {
      var i = i == 0 ? 0 : (i || -1)
      if (i == -1) {
        this.curDepartment = []
      } else {
        if (this.curDepartment.length - i > 1) {
          this.curDepartment.splice(i + 1, this.curDepartment.length - 1 - i)
        }


      }
    },
    // 格式化用户头像
    userNameIcon (name) {
      return name.substring(name.length - 2, name.length)
    },
    // 点击用户
    pickUser (user) {
      if (this.type == 'radio') {

        if (this.curUser[0] == user.id) {
          this.curUser = []
          this.curUserList = []
        } else {

          this.curUser = [user.id]
          this.curUserList = [user]
        }
      } else {
        if (this.curUser.indexOf(user.id) == -1) {
          this.curUser.push(user.id)
          this.curUserList.push(user)
        } else {
          let i = this.curUser.indexOf(user.id)
          this.curUser.splice(i, 1)
          this.curUserList.splice(i, 1)
        }
      }
    },
    // 移除选中用户
    removeSelectedUser (i) {
      this.curUser.splice(i, 1)
      this.curUserList.splice(i, 1)
    },
    // 提交
    submit () {
      if (this.disabled)
        return
      if (this.curUser.length == 0) {
        this.$message({
          message: '未选中用户',
          duration: 1000,
          type: 'error'
        });
        return
      }
      this.disabled = true
      this.$emit('input', this.type == 'radio' ? this.curUserList[0] : this.curUserList)
      this.$emit('change', this.type == 'radio' ? this.curUser[0] : this.curUser, this.type == 'radio' ? this.curUserList[0] : this.curUserList)
      this.close()
    },








    showLoading () {
      this.loading.lock = true
    },
    hideLoading () {
      this.loading.lock = false
    },
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    },






  },
  mounted () {
  }
}
</script>

<style scoped lang="stylus">
div
  box-sizing border-box !important
.h-select-user
  display flex
  flex-direction column
  >>>.el-dialog__header
    border-bottom 1px solid #efefef
  >>>.el-dialog__body
    padding 0
  .user-content
    display flex
    flex-direction row
    height 30vh
    .select-view-icon
      height 16px
      width 16px
      border 2px solid #dcdfe6
      border-radius 50%
      line-height 16px
      text-align center
      // font-size 12px
      font-weight bold
      display flex
      flex-direction row
      justify-content center
      align-items center
      color #ffffff
      margin-right 10px
      margin-left 10px
      // color transparent
      background-color #dcdfe6
    .active
      background-color #3B50FF
      border 2px solid #3B50FF
      color #fff
    .user-selected-view
      flex 1
      height 100%
      border-right 1px solid #efefef
      display flex
      flex-direction column
      padding 20px
      padding-right 10px
      .user-selected-box
        flex 1
        display flex
        flex-direction row
        flex-wrap wrap
        align-content flex-start
        overflow auto
        .user-selected-item
          height 30px
          background-color #f1f1f2
          border-radius 5px
          line-height 30px
          text-align center
          padding 0 10px
          margin-right 10px
          margin-bottom 10px
          cursor pointer
          user-select none
      .current-user
        height 30px
        line-height 30px
        display flex
        flex-direction row
        font-weight bold
      .opt-btn-view
        height 40px
        // background-color red
        display flex
        flex-direction row
        align-content center
        margin-top 10px
    .user-select-view
      flex 1
      height 100%
      padding 20px
      display flex
      flex-direction column
      overflow auto
      .select-view
        height 40px
        width 100%
        display flex
        flex-direction row
        justify-content center
        align-items center
        border-bottom 1px solid #efefef
        cursor pointer
        &:hover
          background-color #efefef
        .select-view-name
          flex 1
          height 40px
          line-height 40px
          padding-left 10px
        .sub-department
          height 20px
          line-height 20px
          width 60px
          border-left 1px solid #C0C4CC
          display flex
          flex-direction row
          justify-content center
          align-items center
          &:hover
            color #3B50FF
      .department-top
        height 20px
        line-height 20px
        font-weight bold
        cursor pointer
        user-select none
      .current-departments
        min-height 20px
        line-height 20px
        display flex
        flex-direction row
        flex-wrap wrap
        .department-name
          color #909399
          height 20px
          cursor pointer
          user-select none
      .department-view
        display flex
        flex-direction column
        .department-view-item
          height 40px
          line-height 40px
      .select-user-view
        display flex
        flex-direction column
        padding-top 20px
        .select-user-item
          height 40px
          display flex
          flex-direction row
          align-items center
          cursor pointer
          &:hover
            background-color #efefef
          .user-icon
            height 30px
            width 30px
            background-color #3B50FF
            border-radius 5px
            color #fff
            line-height 30px
            text-align center
            font-size 11px
            font-weight bold
          .user-name
            flex 1
            height 30px
            line-height 30px
            padding-left 10px
</style>



// WEBPACK FOOTER //
// src/components/parts/hSelectUser.vue